import { Ng2StateDeclaration } from '@uirouter/angular';
import { FiAuthenticateLoginTokenComponent } from '@fi-app/authenticate/login-token/login-token.component';
import { PageTitleService } from '@fi-app/utilities/fi-services/page-title.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

export const FiAuthStatesLoginTokenState: Ng2StateDeclaration = {
    name: FiStateNames.LoginToken,
    url: '/LoginToken?token&url&_d',
    component: FiAuthenticateLoginTokenComponent,
    resolve: {
        pageTitle: [PageTitleService, FiAuthStatesLoginTokenResolve_pageTitle_resolveFunc],
    },
};

export function FiAuthStatesLoginTokenResolve_pageTitle_resolveFunc(pageTitleService: PageTitleService) {
    return pageTitleService.setTitle('Login Token');
}
